<ng-container *ngFor="let name of orderList">

  <ng-container [ngSwitch]="name">


    <ng-container *ngSwitchCase="actionBoxNames.Operations">
      <operations-action-box *ngIf="!disableOptions" [configurationId]="configurationId" [confSessionId]="confSessionId"></operations-action-box>
    </ng-container>


    <ng-container *ngSwitchCase="actionBoxNames.States">
      <states-action-box *ngIf="!disableStates" [configurationId]="configurationId" [confSessionId]="confSessionId"></states-action-box>
    </ng-container>

    <ng-container *ngSwitchCase="actionBoxNames.Revisions">
      <revisions-action-box *ngIf="!disableRevisions" [configurationId]="configurationId" [confSessionId]="confSessionId"></revisions-action-box>
    </ng-container>

    <reports-action-box *ngSwitchCase="actionBoxNames.Reports" [configurationId]="configurationId" [confSessionId]="confSessionId"></reports-action-box>
    <ng-container *ngSwitchCase="actionBoxNames.Forms">
      <form-action-box *ngFor="let model of forms" [form]="model" [configurationId]="configurationId" [confSessionId]="confSessionId"></form-action-box>
    </ng-container>
    <ng-container *ngSwitchCase="actionBoxNames.Code">
      <code-action-box *ngFor="let model of panelValuesModels" [valuesModel]="model" [configurationId]="configurationId" [confSessionId]="confSessionId"></code-action-box>
    </ng-container>

    <ng-container *ngSwitchCase="actionBoxNames.Documents">
      <documents-action-box *ngFor="let item of documentsUIItems" [confUIItem]="item" [configurationId]="configurationId" [confSessionId]="confSessionId"></documents-action-box>
    </ng-container>

    <graphics-action-box *ngSwitchCase="actionBoxNames.Graphics" [configurationId]="configurationId" [confSessionId]="confSessionId"></graphics-action-box>

    <ng-container *ngSwitchCase="actionBoxNames.Attachments">
      <attachments-action-box *ngIf="!disableAttachments" [configurationId]="configurationId" [confSessionId]="confSessionId"></attachments-action-box>
    </ng-container>

  </ng-container>
</ng-container>